// Homepage FAQ (EN + FR): heading, questions, answers and the links under each answer.
// Each language has its own links; on the French page an English-only link goes to the French
// version of that page. The FAQPage structured data (JSON-LD) is built from these items.
const FAQ_DEFAULTS = {
  "en": {
    "eyebrow": "FAQ",
    "title": "Frequently Asked Questions",
    "items": [
      {
        "q": "How much does it cost to hire a security guard in Montreal or Toronto?",
        "a": "Rates depend on the agent tier, schedule and contract length. Standard uniformed guards are the most economical, while specialized intervention or close-protection agents cost more. Request a free quote and we'll reply {quoteReply} with exact pricing.",
        "links": [{ "label": "Get a free quote", "link": "/contact" }]
      },
      {
        "q": "Are your security guards licensed in Quebec and Ontario?",
        "a": "Yes. Vision Security holds agency licence GAR 20062877 from the Bureau de la sécurité privée (Quebec) and PSISA agency licence #30000230 from the Ontario Ministry of the Solicitor General. Every guard is individually licensed, insured and background-checked.",
        "links": [{ "label": "See our licensing & insurance", "link": "/compliance" }]
      },
      {
        "q": "How quickly can you deploy guards to my site?",
        "a": "Urgent requests are staffed {urgent}. Planned contracts start {plannedStart} (larger or specialized teams can take a few days). Alarm calls get {alarm}, and our phones are answered 24/7."
      },
      {
        "q": "Which cities does Vision Security serve?",
        "a": "We serve Montreal, Laval, Quebec City, Trois-Rivières, Toronto, Ottawa and Niagara Falls, with coverage across most of Quebec and Ontario.",
        "links": [
          { "label": "Montreal", "link": "/montreal" },
          { "label": "Laval", "link": "/laval" },
          { "label": "Quebec City", "link": "/quebec-city" },
          { "label": "Toronto", "link": "/toronto" },
          { "label": "Ottawa", "link": "/ottawa" },
          { "label": "Niagara Falls", "link": "/niagara-falls" }
        ]
      },
      {
        "q": "What types of security services do you offer?",
        "a": "Uniformed security guards, mobile patrols, event security, construction site security, fire watch, loss prevention, executive protection and hospitality security — for a one-day event or a year-round contract.",
        "links": [
          { "label": "Event Security", "link": "/services/event-security" },
          { "label": "Construction Security", "link": "/services/construction-site-security" },
          { "label": "Mobile Patrol", "link": "/services/patrol-services" },
          { "label": "Fire Watch", "link": "/services/fire-watch-security" }
        ]
      }
    ]
  },
  "fr": {
    "eyebrow": "FAQ",
    "title": "Questions fréquentes",
    "items": [
      {
        "q": "Combien coûte l'embauche d'un agent de sécurité à Montréal ou Toronto ?",
        "a": "Les tarifs dépendent du type d'agent, de l'horaire et de la durée du contrat. Les agents en uniforme standards sont les plus économiques, tandis que les spécialistes en intervention ou en protection rapprochée coûtent davantage. Demandez une soumission gratuite et nous vous répondrons {quoteReply} avec un prix exact.",
        "links": [{ "label": "Obtenir une soumission gratuite", "link": "/fr/contact" }]
      },
      {
        "q": "Vos agents sont-ils licenciés au Québec et en Ontario ?",
        "a": "Oui. Vision Sécurité détient le permis d'agence GAR 20062877 du Bureau de la sécurité privée (Québec) et le permis d'agence PSISA no 30000230 du ministère du Solliciteur général de l'Ontario. Chaque agent est individuellement licencié, assuré et a fait l'objet d'une vérification d'antécédents.",
        "links": [{ "label": "Voir nos licences et assurances", "link": "/fr/conformite" }]
      },
      {
        "q": "En combien de temps pouvez-vous déployer des agents sur mon site ?",
        "a": "Les demandes urgentes sont comblées {urgent}. Les contrats planifiés débutent {plannedStart} (quelques jours pour les équipes plus grandes ou spécialisées). Les appels d'alarme reçoivent une {alarm}, et nos lignes répondent 24/7."
      },
      {
        "q": "Quelles villes Vision Sécurité dessert-elle ?",
        "a": "Nous desservons Montréal, Laval, Québec, Trois-Rivières, Toronto, Ottawa et Niagara Falls, avec une couverture dans la majeure partie du Québec et de l'Ontario.",
        "links": [
          { "label": "Montréal", "link": "/fr/montreal" },
          { "label": "Laval", "link": "/fr/laval" },
          { "label": "Québec", "link": "/fr/quebec" },
          { "label": "Toronto", "link": "/fr/toronto" },
          { "label": "Ottawa", "link": "/fr/ottawa" },
          { "label": "Niagara Falls", "link": "/fr/niagara-falls" }
        ]
      },
      {
        "q": "Quels types de services de sécurité offrez-vous ?",
        "a": "Agents de sécurité en uniforme, patrouilles mobiles, sécurité événementielle, sécurité de chantier, surveillance incendie, prévention des pertes, protection rapprochée et sécurité hôtelière — pour un événement d'une journée ou un contrat annuel.",
        "links": [
          { "label": "Sécurité événementielle", "link": "/fr/services/securite-evenementielle" },
          { "label": "Sécurité de chantier", "link": "/fr/services/securite-chantier" },
          { "label": "Patrouille mobile", "link": "/fr/services/patrouille-mobile" },
          { "label": "Surveillance incendie", "link": "/fr/services/surveillance-incendie" }
        ]
      }
    ]
  }
};

export default FAQ_DEFAULTS;
